import { render, staticRenderFns } from "./ShoppingTitle.vue?vue&type=template&id=3654dc1c&scoped=true"
import script from "./ShoppingTitle.vue?vue&type=script&lang=js"
export * from "./ShoppingTitle.vue?vue&type=script&lang=js"
import style0 from "./ShoppingTitle.vue?vue&type=style&index=0&id=3654dc1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3654dc1c",
  null
  
)

export default component.exports